

export default async (to, from, next) => {

  const params = new URLSearchParams(window.location.search);
  var passedToken = params.get('t');
  console.log(passedToken);
  if (passedToken) {
    await localStorage.setItem('currencyToken', passedToken);
    window.location.href = window.location.origin + '/web';
    return;
  }
  var token = localStorage.getItem("currencyToken") || '';

  // console.log(to);

    if (token.length > 0) {
      // if (userInfo.password2 == null) {
      //   next('/web/set-sec-password');
      // }
      next();
    } else {
      localStorage.removeItem("currencyToken");
      next('/web/sessions/login');
    }
  
};
